/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const ShareLinkIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0)" fill={color}>
        <path d="M.97 11.089a3.321 3.321 0 000 4.69c.647.648 1.496.97 2.346.97.85 0 1.699-.322 2.346-.97l9.368-9.368a3.321 3.321 0 000-4.691 3.321 3.321 0 00-4.691 0L.97 11.089zm4.24 4.24a2.683 2.683 0 01-3.789 0 2.683 2.683 0 010-3.79l3.23-3.23-.005.03a3.36 3.36 0 00.235 1.798l-2.431 2.43a1.227 1.227 0 00.866 2.092c.328 0 .635-.127.866-.358l4.502-4.502.109-.109.148-.148A1.227 1.227 0 008.419 7.5l1.088-1.088a2.675 2.675 0 01.946 1.03c.54 1.043.345 2.3-.484 3.129l-4.758 4.758zm2.3-6.09a.588.588 0 010-.83l.149-.149a.588.588 0 01.83.832l-.147.148a.589.589 0 01-.831 0zm3.288-2.456a3.315 3.315 0 00-.831-.83l2.302-2.303a.588.588 0 01.831.831l-2.302 2.302zm-5.595 3.933a3.312 3.312 0 00.83.832L3.733 13.85a.588.588 0 01-.832-.832l2.303-2.302zM14.58 5.96l-3.23 3.23.005-.029a3.36 3.36 0 00-.235-1.798l2.431-2.431a1.227 1.227 0 00-.866-2.091c-.328 0-.636.127-.867.358L7.318 7.7l-.11.11-.148.147A1.227 1.227 0 007.582 10l-1.089 1.09a2.671 2.671 0 01-.946-1.032 2.672 2.672 0 01.484-3.128L10.79 2.17a2.683 2.683 0 013.79 0 2.683 2.683 0 010 3.79z" />
        <path d="M10.77 2.787l-.51.51a.319.319 0 10.451.451l.51-.51a.319.319 0 10-.45-.45zM9.464 4.094l-3.22 3.22a.319.319 0 00.451.45l3.22-3.219a.319.319 0 00-.451-.45z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
